import JwtService from "@/utils/jwt.service";

export default {

    setAuth(state, token) {
        state.isAuthenticated = true;
        JwtService.saveToken(token.token);
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    purge_auth(state) {
        state.isAuthenticated = false;
        state.user = {};
        state.errors = null;
        JwtService.destroyToken();
    },
    setUser(state, user) {
        state.user = user;
    }
}